export default __webpack_public_path__ + "static/media/FCMB_Logo.9e83faae.png";